/**
 * アプリ内通知 (ポップアップ / 通知音) のユーザー個人設定。
 *
 * 設定は **サーバー側のユーザー個人設定** (GET/PUT /admin/users/me/preferences) に永続化する。
 * 同一アカウントなら別 PC・別ブラウザでも反映される。
 *
 * 格納先: `preferences.notifications` 配下に `inAppPopup` / `inAppSound` (boolean) として持つ。
 *   - BE GET は `preferences.notifications` を verbatim で返すため、この入れ子なら round-trip する
 *     (トップレベルの未知フィールドは BE GET のマッピングで欠落するため不可)。
 *
 * このモジュールは取得レスポンスから設定を取り出す純粋関数のみを持つ (localStorage 不使用)。
 */

export interface InAppNotificationPreferences {
  /** 新着時に画面右上ポップアップを表示するか */
  inAppPopup: boolean;
  /** 新着時に通知音を鳴らすか */
  inAppSound: boolean;
}

/** 既定値: ポップアップ ON、通知音 OFF (予期しない音を鳴らさない)。 */
export const DEFAULT_IN_APP_NOTIFICATION_PREFERENCES: InAppNotificationPreferences = {
  inAppPopup: true,
  inAppSound: false,
};

/**
 * サーバー個人設定の `notifications` サブオブジェクトから、アプリ内通知設定を取り出す純粋関数。
 * 未保存 / 不正値 / 型違いはすべて default にフォールバックする (後方互換: 既存ユーザーは default)。
 */
export function parseInAppNotificationPreferences(
  notifications: Record<string, unknown> | null | undefined,
): InAppNotificationPreferences {
  const n = notifications ?? {};
  return {
    inAppPopup:
      typeof n.inAppPopup === 'boolean'
        ? n.inAppPopup
        : DEFAULT_IN_APP_NOTIFICATION_PREFERENCES.inAppPopup,
    inAppSound:
      typeof n.inAppSound === 'boolean'
        ? n.inAppSound
        : DEFAULT_IN_APP_NOTIFICATION_PREFERENCES.inAppSound,
  };
}
